import { motion } from "motion/react";
import { Settings, Link, Brain, MessageSquare, Shield, Headphones } from "lucide-react";
import { useTranslation } from "react-i18next";

const ICONS = [Settings, Link, Brain, MessageSquare, Shield, Headphones] as const;

export default function Services() {
  const { t } = useTranslation();

  return (
    <section id="services" className="py-24 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-on-surface mb-4">{t('services.title')}</h2>
          <p className="text-on-surface-variant max-w-xl">{t('services.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ICONS.map((Icon, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              whileHover={{ y: -5 }}
              className="bg-surface-container-low border border-outline-variant p-8 rounded-xl hover:border-primary-container transition-all group"
            >
              <div className="w-12 h-12 bg-primary-container/10 rounded-lg flex items-center justify-center text-primary-container mb-6 group-hover:bg-primary-container group-hover:text-white transition-all">
                <Icon className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-on-surface mb-3">{t(`services.items.${idx}.title`)}</h3>
              <p className="text-on-surface-variant text-sm leading-relaxed">{t(`services.items.${idx}.description`)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
